export default __webpack_public_path__ + "static/media/11_CAMP_OUGANDA_01-min.2dac4ffc.jpg";